import { en } from './en'
import { zh } from './zh'

export type {
  AdvantageLocale,
  CaseEntry,
  CaseMetric,
  CasesLocale,
  ChangePropagationLocale,
  ChatLocale,
  CitationLocale,
  ContinuousAuditLocale,
  DocumentDrivenLocale,
  EventDrivenLocale,
  ExplainabilityLocale,
  GoalDrivenLocale,
  GoalLocale,
  IndustryDemoPack,
  IndustryLocale,
  LabDemosLocale,
  LabPageLocale,
  LayerMetaLocale,
  Locale,
  MatrixRowLocale,
  MethodLocale,
  MultiAgentLocale,
  ParadigmLocale,
  ParadigmScenarioLocale,
  ParadigmsPageLocale,
  PathLabelsCompliance,
  PathLabelsCost,
  PathLabelsUptime,
  PlaybookBlock,
  PlaybookLocale,
  PlaybookSection,
  QuestionGroundedLocale,
  RiskScoringLocale,
  SopStepLocale,
  ToolCallLocale,
  WhatIfLocale,
} from './types'

export const LOCALES = { en, zh } as const
